export default __webpack_public_path__ + "static/media/ripple.795f1eea.svg";